import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { TApiServiceError } from "../apiService";
import { versionService } from "./version.service";
import { TVersionResponse } from "./version.types";

export const GET_VERSION_QUERY_KEY = "version";

/**
 * Custom hook to fetch backend version using React Query.
 * @param options - Optional configuration for the React Query `useQuery` hook, excluding `queryKey` and `queryFn`.
 * @returns The result of the `useQuery` hook for fetching version information.
 */
export const useGetVersionQuery = (
  options?: Omit<
    UseQueryOptions<TVersionResponse, TApiServiceError>,
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery({
    queryKey: [GET_VERSION_QUERY_KEY],
    queryFn: () => versionService.getVersion(),
    ...options,
  });
};
